import {Action, getModule, Module, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {ICategory, ICategoryRepo} from "@/entity/category/category.types";
import { prepareFormData } from '@/store/utils/formDataHelper'
import { PaginationRequestType } from "@/entity/common/pagination.types"
@Module({
    namespaced: true,
    name: 'category',
    store,
    dynamic: true,
})
class ClientCategoryModule extends VuexModule {
    category: ICategoryRepo | null = null;
    categoryLoaded = false;
    categorLoaded = false;

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ category: ICategoryRepo; categoryLoaded: boolean }> {
        const category = await store.$repository.categoryClient.fetchAll(prepareFormData(data));
        let categoryLoaded = false;
        if (category) {
            categoryLoaded = true;
        }
        return {category, categoryLoaded};
    }
}

export const ClientCategoryStore = getModule(ClientCategoryModule);
